import e from"react";import o from"@mui/material/InputAdornment";import t from"../../../../Icons/components/Icons/Done.js";const n=()=>e.createElement(o,{position:"end"},e.createElement(t,{color:"green300",size:"small"}));export{n as ValidAdornment};
//# sourceMappingURL=ValidAdornment.js.map
